import PageHeader from "../components/PageHeader";
import { ArrowUpRight } from "@phosphor-icons/react";
import SEOMeta from "../components/SEOMeta";

const CONTACTS = [
  {
    key: "mandates",
    label: "Discuss a mandate",
    description: "For prospective clients exploring an engagement.",
    email: "mandates@dugavuventures.com",
    primary: true
  },
  {
    key: "rfp",
    label: "Procurement and tenders",
    description: "For procurement officers requesting capability statements, prequalification documents, or submitting expressions of interest.",
    email: "rfp@dugavuventures.com"
  },
  {
    key: "info",
    label: "General",
    description: "For general enquiries.",
    email: "info@dugavuventures.com"
  },
  {
    key: "press",
    label: "Press and media",
    description: "For media enquiries.",
    email: "press@dugavuventures.com"
  }
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SEOMeta
        title="Contact"
        description="Contact Dugavu Ventures to discuss a consulting mandate in corporate strategy, mining, minerals, oil and gas, or public-sector advisory. Based in Kampala, serving clients globally."
        url="/contact"
      />
      <PageHeader
        eyebrow="Contact"
        title="Direct lines, by purpose."
        lede="Dugavu Ventures welcomes enquiries from prospective clients and procurement teams. The routes below are designed to direct your enquiry to the right person quickly."
        testid="contact-header"
      />

      <section className="py-20 md:py-28" data-testid="contact-grid">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="mb-12 grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-3">
              <div className="eyebrow">Engagement routes</div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-rule border-t border-b border-rule">
            {CONTACTS.map((c) => (
              <a
                key={c.key}
                href={`mailto:${c.email}`}
                data-testid={`contact-${c.key}`}
                className={`group p-10 md:p-12 transition-colors duration-500 ${
                  c.primary ? "bg-oxblood text-white hover:bg-oxblood-hover" : "bg-bone hover:bg-subtle"
                }`}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="flex-1">
                    <div className={`text-[11px] tracking-widest uppercase font-mono ${c.primary ? "text-white/70" : "text-slate"}`}>
                      {c.primary ? "Primary" : "Direct line"}
                    </div>
                    <h2 className={`font-serif text-3xl md:text-4xl mt-3 leading-tight ${c.primary ? "text-white" : "text-ink"}`}>{c.label}</h2>
                    <p className={`mt-4 text-[15px] leading-relaxed max-w-md ${c.primary ? "text-white/80" : "text-charcoal"}`}>
                      {c.description}
                    </p>
                    <div className={`mt-8 font-mono text-[14px] tracking-tight ${c.primary ? "text-white" : "text-oxblood"} link-rule inline-block`}>
                      {c.email}
                    </div>
                  </div>
                  <ArrowUpRight
                    size={24}
                    weight="thin"
                    className={`flex-shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 ${c.primary ? "text-white" : "text-ink"}`}
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Office */}
      <section className="py-20 md:py-28 bg-subtle" data-testid="contact-office">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
            <div className="md:col-span-3">
              <div className="eyebrow">Office</div>
            </div>
            <div className="md:col-span-9">
              <address className="not-italic">
                <div className="font-serif text-3xl md:text-4xl text-ink leading-tight">Dugavu Ventures Ltd</div>
                <div className="mt-5 font-serif text-2xl text-charcoal leading-snug">
                  Kampala, Uganda
                </div>
              </address>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
